import React from 'react';
import Kicker from '../ui/Kicker';

const CAPABILITIES = [
  {
    id: 'AI',
    name: 'AI & Agents',
    desc: 'Copilots, agents and automation wired into the systems your team already works in — not another tool nobody opens.',
  },
  {
    id: 'ML',
    name: 'Machine Learning & Data',
    desc: 'Forecasting, classification and decision models built on your data, with the pipelines and monitoring that keep them honest.',
  },
  {
    id: 'PROTO',
    name: 'Rapid Prototyping',
    desc: 'Idea to working MVP in weeks, so the business case gets argued against something real instead of a projection.',
  },
  {
    id: 'XR',
    name: 'Immersive & Spatial',
    desc: 'VR training, digital twins and virtual environments for the work that is hard to teach on a flat screen.',
  },
  {
    id: 'CHAIN',
    name: 'Blockchain & Provenance',
    desc: 'Supply chain traceability and smart contracts for the cases where trust between parties is the actual bottleneck.',
  },
  {
    id: 'ENABLE',
    name: 'Change Enablement',
    desc: 'Upskilling, operating models and partnerships, so the capability outlives the engagement that created it.',
  },
];

export default function Capabilities() {
  return (
    <section id="capabilities" aria-label="Capabilities">
      <div className="container">
        <div className="section-head centered reveal">
          <Kicker>What we build</Kicker>
          <h2 className="section-title">Capabilities</h2>
          <p className="section-sub">
            AI leads most engagements. The rest of the stack exists because transformation
            rarely stops at a model.
          </p>
        </div>

        <div className="cap-grid">
          {CAPABILITIES.map((cap) => (
            <article className="card reveal" key={cap.id}>
              <span className="card-index">[{cap.id}]</span>
              <h3>{cap.name}</h3>
              <p>{cap.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
